var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 108,
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#303C42",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a.5.5 0 11-1 0 .5.5 0 011 0zM4.5 4V1.5M10 4a.5.5 0 11-1 0 .5.5 0 011 0zM9.5 4V1.5M15 4a.5.5 0 11-1 0 .5.5 0 011 0zM14.5 4V1.5M19.875 3.375l3.75 3.75M8 15.25h1.875l.625 1.25 1.25.625.625 1.25M6 20.5l.5.5M21.691 5.309l-11.19 11.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.628V3A1.5 1.5 0 0017 1.5H2A1.5 1.5 0 00.5 3v22A1.5 1.5 0 002 26.5h15a1.5 1.5 0 001.5-1.5V12.327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 19L24.951 5.951c.339-.34.549-.808.549-1.326s-.21-.986-.549-1.326l-1.25-1.25a1.871 1.871 0 00-1.326-.549c-.518 0-.986.21-1.326.549L8 15.25 5.5 21.5l6.25-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 19L24.951 5.951c.339-.34.549-.808.549-1.326s-.21-.986-.549-1.326l-1.25-1.25a1.871 1.871 0 00-1.326-.549c-.518 0-.986.21-1.326.549L8 15.25 5.5 21.5l6.25-2.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.812d7c8877bcbf948303c3393bbeba27.svg";
export { ForwardRef as ReactComponent };